import React, { useState, useEffect } from 'react'
import './intro.css'
import bg from '../../assets/image.png'


const Intro = () => {
  const [helloText, setHelloText] = useState('');
  const [nameText, setNameText] = useState('');
  const [titleText, setTitleText] = useState('');
  const [descriptionText, setDescriptionText] = useState('');
  const [description2Text, setDescription2Text] = useState('');
  const [showCursor, setShowCursor] = useState(true);
  const [currentStage, setCurrentStage] = useState(0);
  
  useEffect(() => {
    const hello = "Hello";
    const name = "I'm Mohsin,";
    const title = "a Software Engineer";
    const description = "I'm passionate about creating innovative solutions";
    const description2 = "and eager to collaborate on impactful projects";
    
    let stage = 0;
    let currentIndex = 0;
    let pauseCounter = 0;
    const pauseDuration = 8; // Pause for 8 intervals (about 640ms at 80ms per interval)
    
    const typingInterval = setInterval(() => {
      // Check if we're in a pause between stages
      if (pauseCounter > 0) {
        pauseCounter--;
        setCurrentStage(-1); // No active typing during pause
        return;
      }
      
      // Stage 1: Type "Hello"
      if (stage === 0) {
        if (currentIndex < hello.length) {
          setHelloText(hello.slice(0, currentIndex + 1));
          setCurrentStage(0);
          currentIndex++;
        } else {
          stage = 1;
          currentIndex = 0;
          pauseCounter = pauseDuration;
        }
      }
      // Stage 2: Type "I'm Mohsin,"
      else if (stage === 1) {
        if (currentIndex < name.length) {
          setNameText(name.slice(0, currentIndex + 1));
          setCurrentStage(1);
          currentIndex++;
        } else {
          stage = 2;
          currentIndex = 0;
          pauseCounter = pauseDuration;
        }
      }
      // Stage 3: Type "a Software Engineer"
      else if (stage === 2) {
        if (currentIndex < title.length) {
          setTitleText(title.slice(0, currentIndex + 1));
          setCurrentStage(2);
          currentIndex++;
        } else {
          stage = 3;
          currentIndex = 0;
          pauseCounter = pauseDuration;
        }
      }
      // Stage 4: Type description part 1
      else if (stage === 3) {
        if (currentIndex < description.length) {
          setDescriptionText(description.slice(0, currentIndex + 1));
          setCurrentStage(3);
          currentIndex++;
        } else {
          stage = 4;
          currentIndex = 0;
          pauseCounter = pauseDuration;
        }
      }
      // Stage 5: Type description part 2
      else if (stage === 4) {
        if (currentIndex < description2.length) {
          setDescription2Text(description2.slice(0, currentIndex + 1));
          setCurrentStage(4);
          currentIndex++;
        } else {
          clearInterval(typingInterval);
          setShowCursor(false);
        }
      }
    }, 50);
    
    return () => clearInterval(typingInterval);
  }, []);
  return (
    <section id="intro">
        <div className="introContent">
            <span className="hello">{helloText}{helloText && helloText.length === 5 && currentStage === 0 && showCursor ? <span className="cursor">|</span> : ''}</span>
            <span className="introText">
              <span className="introName">{nameText}</span>
              {nameText && nameText.length === 11 && currentStage === 1 && showCursor ? <span className="cursor">|</span> : ''}
              {nameText && nameText.length === 11 && <br />}
              <span className="introTitle">{titleText}</span>
              {titleText && titleText.length > 0 && titleText.length < 20 && currentStage === 2 && showCursor ? <span className="cursor">|</span> : ''}
            </span>
            <p className="introPara">
              {descriptionText}
              {descriptionText && descriptionText.length > 0 && descriptionText.length < 50 && currentStage === 3 && showCursor ? <span className="cursor">|</span> : ''}
              {descriptionText && descriptionText.length === 50 && <br />}
              {description2Text}
              {description2Text && description2Text.length > 0 && description2Text.length < 48 && currentStage === 4 && showCursor ? <span className="cursor">|</span> : ''}
            </p>
        </div>
        <img src={bg} alt="Mohsin Shah Profile" className="bg" />
    </section>
  );
}

export default Intro;